import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { DataCollectorService } from '../utility/data_collector.service';
import { HlmDialogService } from '../../../../../spartan_libs/ui-dialog-helm/src';

@Injectable({
  providedIn: 'root'
})
export class WorkflowService {

  apiUrls: any = {
    'workflows': this._dataCollectorService.baseUrl + '/workflows',
    'workflow': this._dataCollectorService.gateKeeprUrl + 'workflow',
    'variables': this._dataCollectorService.baseUrl + '/variables',
    'need_attention': this._dataCollectorService.baseUrl + '/need_attention'
  }

  workflowChange$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  
  private readonly _hlmDialogService = inject(HlmDialogService);
  

  constructor(
    private _dataCollectorService: DataCollectorService
  ) { }

  getExecutionDetailsUrl(workflowUid: string, executionUid: string): string {
    return this.apiUrls.workflows + `/${workflowUid}/executions/${executionUid}`;
  }

  getStopExecutionUrl(workflow_uid: string, execution_uid: string): string {
    return this.apiUrls.workflow + `/${workflow_uid}/execution/${execution_uid}/stop`
  }

  getWorkflowActivationUrl(workflowUid: string, executionUid: string, nodeUid: string): string {
    return  this.apiUrls.workflow + `/${workflowUid}/execution/${executionUid}/activate/node/${nodeUid}`
  }

  getRetryUrl(workflowUid: string, executionUid: string, nodeUid: string): string {
    return this.apiUrls.workflow + `/${workflowUid}/execution/${executionUid}/retry/node/${nodeUid}`
  }

  setActivation(state: 'active' | 'deactive' | 'delete', fn: any, component: any, workflowName: string): void {
    let message, title, submit, type;
        if(state === 'active'){
          type = "ACTIVATE";
          title = 'Activate workflow?';
          submit = 'Yes, Activate'
          message = `Activating this workflow will start tracking live triggers and making updates as configured. Are you sure you want to turn it on?`
        }else if(state === 'deactive'){
          type = "ACTIVATE";
          title = 'Deactivate workflow?'
          submit = 'Yes, Deactivate'
          message = `Deactivating this workflow will stop tracking live triggers and making updates. Are you sure you want to turn it off?`
        }else if(state === 'delete'){
          type = "DELETE";
          title = 'Delete workflow?'
          submit = 'Yes, Delete'
          message = `Do you want to permanently delete the workflow "${workflowName}"?`
        }
        const dialogRef = this._hlmDialogService.open(component, {
            context: {
                data: {
                  type,
                  title,
                  message,
                  button: {
                    close: 'Cancel',
                    submit: submit
                  }
                },
            },
            contentClass: 'max-w-[500px]',
        });

        dialogRef.closed$.subscribe(fn);
  }
}
